<template>
    <div id="faq">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">Часто задаваемые вопросы</h1><Breadcrumbs title="Часто задаваемые вопросы"/></div>
        </section>
        <section class="section mt-2 pb-0">
            <div class="container">
                
                <div class="row">
                    <div class="accordion" role="tablist">
                        <card no-body class="mb-1 card-item" v-for="(item, index) in text" :key="item.ID" style="border:none">
                            <div header-tag="header" class="p-1 title" role="tab">
                                <div class="title" block v-b-toggle="'accordion-'+index" variant="info">
                                        <h3>{{item.NAME}}</h3>
                                         <span class="when-opened plus">
                                            +
                                        </span>
                                        <span class="when-closed plus">
                                            +
                                        </span>
                                </div>
                            </div>
                            <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
                                <p>{{item.DETAIL_TEXT}}</p>
                            </b-collapse>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <h4 style="text-align:center; margin-top:30px;">Задать свой вопрос</h4>
        <ContactForm></ContactForm>
    </div>
</template>
<script>
    import ContactForm from "@/components/ContactForm.vue";
    import Breadcrumbs from "@/components/Breadcrumbs.vue";
    export default {
        components: {
            ContactForm,
            Breadcrumbs
        },
        data() {
            return {
                text: []
            };
        },
        methods: {
            async loadInfo(id_tab) {
                let params = new Map();
                params.set('entity', 'faq');
                this.text = await this.$root.loadContent(params)

                let paramsPage = new Map();
                paramsPage.set("code", "faq");
                paramsPage.set("entity", "pages");

                let seo = await this.$root.loadContent(paramsPage);
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            },
        },
        created() {
            this.loadInfo()
        },
    };
</script>
<style scoped>
    .accordion{
        width: 75%;
        margin: 0 auto;
    }
    .title{
        position: relative;
        display:block;
        width: 100%;
        cursor: pointer;
    }
    .title:hover > .plus{
        background: #ced4da;
    }
    h3{
        width: 90%;
    }
    .plus{
        position: absolute;
        width: 30px;
        height: 30px;
        line-height: 30px;
        right:0;
        top:5px;
        text-align: center;
        font-size: 21px;
        font-weight: 600;
        border-radius: 15px;
    }
    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
    .collapsed > .when-closed {
        display: inline-block;
        -moz-transform: rotate(0deg); /* Для Firefox */
        -ms-transform: rotate(0deg); /* Для IE */
        -webkit-transform: rotate(0deg); /* Для Safari, Chrome, iOS */
        -o-transform: rotate(0deg); /* Для Opera */
        transform: rotate(0deg);
   }
    :not(.collapsed) > .when-opened {
        display: inline-block;
        -moz-transform: rotate(45deg); /* Для Firefox */
        -ms-transform: rotate(45deg); /* Для IE */
        -webkit-transform: rotate(45deg); /* Для Safari, Chrome, iOS */
        -o-transform: rotate(45deg); /* Для Opera */
        transform: rotate(45deg);
   }
   ::v-deep .shape, ::v-deep .section-shaped .text-center{
       display:none !important;
   }
</style>